/* unplugin-vue-components disabled */import { render } from "./CustomerCreate.vue?vue&type=template&id=25e369c6&ts=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerCreate.vue?vue&type=script&lang=ts"

import "./CustomerCreate.vue?vue&type=style&index=0&id=25e369c6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__